import { addDays, addMonths, startOfDay } from 'date-fns';
export function getDateRange(now) {
    const minDate = startOfDay(addDays(now, 1));
    const maxDate = startOfDay(addMonths(now, 4));
    return {
        minDate,
        maxDate
    };
}
export function getDaysOptions() {
    return Array.from({
        length: 90
    }, (_, i)=>i + 1);
}
